export enum JSRuleErrorType {
    Value = 1,
    Type = 2,
    /**
     * Error cuando se hace referencia a una valor que no existe (NULL)
     */
    Reference = 3,
}